
import { Stack, Tooltip, Box, Typography } from '@mui/material';
import moment from 'moment';

const fallsInTime = (timeToCheck, startTime, endTime) => {
    timeToCheck = moment(timeToCheck, 'DD-MM-YYYY HH:mm')
    startTime = moment(startTime, 'DD-MM-YYYY HH:mm')
    endTime = moment(endTime, 'DD-MM-YYYY HH:mm')
    return timeToCheck.isBetween(startTime, endTime, undefined, '[)');
}

const IndSquare = ({date, hour, bookings, item, sku, isMobile}) => {    
    const isOccupied = bookings.find(booking => {
    const timeMatch = fallsInTime(`${date} ${hour}:00`, moment(booking.from).format('DD-MM-YYYY HH:mm'), moment(booking.to).format('DD-MM-YYYY HH:mm'))
    const itemMatch = booking.items.find(_item => _item.item === item)
    return timeMatch && itemMatch 
    })
    const background = isOccupied ? 'red' : 'green'
    return (<Tooltip title={`${hour}:00 (${sku}) `}><Box sx={{backgroundColor: background, height:"10px", width: isMobile? "8%" : "10px", mr: 0.25}}></Box></Tooltip>)    
}

const SquareRow = ({date, bookings, item, sku, isMobile}) => {
    const rows = [];
    for (let i = 8; i < 23; i += 1) {
        rows.push(<IndSquare isMobile={isMobile} hour={i} bookings={bookings} date={date} item={item} sku={sku}/>)
    }
    return (
        <Stack direction="row" justifyContent="center">
            {rows}
        </Stack>
    );
}

const IndSquareDetail = ({date, hour, bookings, item, sku, isMobile}) => {
    if (bookings) {
        const isOccupied = bookings.find(booking => {
        const timeMatch = fallsInTime(`${date} ${hour}:00`, moment(booking.from).format('DD-MM-YYYY HH:mm'), moment(booking.to).format('DD-MM-YYYY HH:mm'))
        const itemMatch = booking.items.find(_item => _item.item === item)
        return timeMatch && itemMatch 
        })
        const background = isOccupied ? 'red' : 'green'
        return (<Box sx={{backgroundColor: background, height:"10px", width: isMobile? "8%" : "10px", mr: 0.5}}></Box>)
    }
    return (<Box sx={{height:"10px", width: isMobile? "8%" : "10px", mr: 0.5, textAlign: "center"}}><Typography sx={{fontSize: 8}}>{hour}</Typography></Box>)
}

const SquareRowDetail = ({date, bookings, item, sku, isMobile}) => {
    const rows = [];
    for (let i = 8; i < 23; i += 1) {
        rows.push(<IndSquareDetail isMobile={isMobile} hour={i} bookings={bookings} date={date} item={item} sku={sku}/>)
    }
    return (
        <Stack direction="row" alignItems="center">
            {sku && (<Typography sx={{ mr: 2, overflow: 'hidden', fontSize: 12 }}>{sku}</Typography>)}
            {rows}
        </Stack>
    );
}

export { SquareRow, SquareRowDetail }